import { useMemo } from 'react';

import { type CustomerResource, validateResourceFileType } from 'src/data/performance';
import { useResources } from 'src/services/useResources';

interface Params {
  displayResourceTypes: string[];
  allowedFileTypes?: string[];
}

export const useVisibleResources = ({
  displayResourceTypes,
  allowedFileTypes,
}: Params): CustomerResource[] => {
  const { resources } = useResources();

  return useMemo(() => {
    const onlyVisibleResources = (resource: CustomerResource) => {
      if (!displayResourceTypes.includes(resource.contentType)) {
        return false;
      }

      if (Array.isArray(allowedFileTypes) && allowedFileTypes.length > 0) {
        return validateResourceFileType(resource, allowedFileTypes);
      }

      return true;
    };

    return (resources || []).filter(onlyVisibleResources);
  }, [resources, displayResourceTypes, allowedFileTypes]);
};
